import { create } from "zustand";
import produce from "immer";
import { useEffect } from "react";

export const useStepNumber = create((set, get) => ({
    last_step: 1,
    setStep: (step_number) => {
        set(
            produce((state) => {
                state.last_step =
                    get().last_step > step_number
                        ? get().last_step
                        : step_number;
            })
        );
    },
}));

// * FACADE
// * FACADE
// * FACADE
export const useSetStep = (step) => {
    const setStep = useStepNumber((state) => state.setStep);
    useEffect(() => {
        setStep(step);
    }, [setStep]);
    return;
};
